import React, { Component } from "react";
import { Form, Select, Input, Button } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import * as diffObject from "deep-object-diff";
import URLParser from "../../helpers/url-parser.helper";
import {
  parseSearchUrl,
  parseFilterToField,
} from "../../helpers/filter.helper";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import "./style.less";

export interface SelectData {
  value: any;
  text: string;
}

export interface ChangeValues {
  fieldName: string | string[];
  value: string | Array<any>;
}

export enum Types {
  SELECT,
  RADIO,
  INPUT,
}

type FiltersProps = {
  dispatches?: Array<(args: SearchRequest) => void | any>;
  children: any;
  defaultSubmitOptions: SearchRequest;
  submitDispatch: (args: SearchRequest) => void;

  loading: boolean;
  size: any;
  history?: any;

  onSubmit?: (args: SearchRequest) => void;
  onClearFilters?: () => void;
};

type FilterItemProps = {
  name: string | string[];
  type: Types;
  data?: string | Array<SelectData>;
  value?: string | string[];
  defaultValue?: string;
  label?: string;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
  size: any;
  options: {
    input?: {
      allowClear?: boolean;
    };
    select?: {
      allowClear?: boolean;
      showSearch?: boolean;
      optionFilterProp?: string;
      onSearch?: ( args: SearchRequest) =>  void,
      onDropdownVisibleChange?: (open: boolean) => void
    };
  };
  onChange: (args: ChangeValues) => void;
};

/**
 * Filters
 */
export default class Filters extends Component<FiltersProps> {
  static defaultProps = {
    loading: false,
    size: "large",

    defaultSubmitOptions: {},
    submitDispatch: () => {},

    onSubmit: () => {},
    onClearFilters: () => {},
  };

  state = {
    filters: {} as any,
  };

  prevUrlFilters: any = {};

  constructor(props) {
    super(props);

    this.state = {
      filters: parseSearchUrl("filter_"),
    };
  }

  componentDidMount() {
    const { dispatches } = this.props;
    const { filters } = this.state;

    if (dispatches) {
      dispatches
        .filter((dispatch) => typeof dispatch === "function")
        .forEach((dispatch) => {
          dispatch({
            search: {
              deleted: false,
            },
            options: {
              limit: 999,
              _force_ids: true,
            },
          });
        });
    }

    if (Object.keys(filters).length > 0) {
      setTimeout(() => {
        this.handleFilterSubmit();
      }, 1000);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters } = this.state;
    const urlFilters = parseSearchUrl("filter_");
    // Trick to get diff without undefined :P
    const urlFiltersDiff = JSON.parse(
      JSON.stringify(diffObject.diff(this.prevUrlFilters, urlFilters))
    );
    if (Object.keys(urlFiltersDiff).length > 0) {
      const diff = JSON.parse(
        JSON.stringify(diffObject.diff(filters, urlFilters))
      );

      if (Object.keys(diff).length > 0) {
        this.setState(
          {
            filters: parseSearchUrl("filter_"),
          },
          () => {
            this.handleFilterSubmit();
          }
        );
      }
    }

    this.prevUrlFilters = JSON.parse(JSON.stringify(urlFilters));
  }

  handleFilterChange = (data: ChangeValues) => {
    let { filters } = this.state;
    const v = data?.value &&  Array.isArray( data.value ) ? data.value: data?.value && (data.value as string).split(" ")

    if (Array.isArray(data.fieldName)) {
      if (Array.isArray(v)) {
        for (var i = 0; i < data.fieldName.length; i++) {
          if (data.value !== undefined && v.length > 0) {
            filters[data.fieldName[i]] = data.value.toString() ;
          } else {
            delete filters[data.fieldName[i]];
          }
        }
      }
      this.setState({
        filters,
      });
      return;
    }
    

    // If we do have a valid filter value, so we can add or update it. Otherwise we should remove it
    if (data.value !== undefined && data.value.toString().length > 0) {
      filters[data.fieldName] = data.value.toString();
    } else {
      delete filters[data.fieldName];
    }

    this.setState({
      filters,
    });
  };

  handleFilterClear = () => {
    const {
      history,
      defaultSubmitOptions,
      submitDispatch,
      onSubmit,
      onClearFilters,
    } = this.props;

    URLParser.removeAllParams(history);
    this.setState(
      {
        filters: {},
      },
      () => {
        submitDispatch(defaultSubmitOptions);

        if (onSubmit) {
          onSubmit(defaultSubmitOptions);
        }

        // Clear fields callback
        if (onClearFilters) {
          onClearFilters();
        }
      }
    );
  };

  validarUUID = (uuid) => {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);  
  };

  handleParseValues = (key, value) => {
    if (key === "uuid") {
      if (!this.validarUUID(value)) {
        return false;
      }
    }
    return true;
  };

  handleFilterSubmit = () => {
    const { history, defaultSubmitOptions, submitDispatch, onSubmit } =
      this.props;
    const { filters } = this.state;

    let extras: any = {};

    // Remove all URL search params
    URLParser.removeAllParams(history);

    const params = [] as any;
    Object.keys(filters).forEach((key) => {
      let value = filters[key];

      if (typeof value === "string") {
        value = value.trim();
      }

      if (!this.handleParseValues(key, value)) {
        return false;
      }
      // Parse filter field
      extras = {
        ...extras,
        ...parseFilterToField(extras, key, value, defaultSubmitOptions),
      };

      params.push({
        key: `filter_${key}`,
        value,
      });
    });
    // Update URL search params
    URLParser.setParams(history, params);

    const payload = {
      ...defaultSubmitOptions,
      search: {
        ...defaultSubmitOptions.search,
        ...extras,
      },
    } as SearchRequest;

    if (onSubmit) {
      onSubmit(payload);
    }

    submitDispatch(payload);
  };

  render() {
    const { children, loading, size } = this.props;

    return (
      <Form className="filters-container" onFinish={this.handleFilterSubmit} layout="vertical">
        <div style={{ width: "100%" }}>
          {children
            ? children({
                values: this.state.filters,
                handleFilterChange: this.handleFilterChange,
              })
            : null}
        </div>

        <div className="filters-actions">
          <Button
            type="primary"
            size={size}
            htmlType="submit"
            icon={<SearchOutlined />}
            loading={loading}
          >
            Search
          </Button>
          <Button
            type="default"
            size={size}
            htmlType="reset"
            icon={<ClearOutlined />}
            loading={loading}
            onClick={this.handleFilterClear}
          >
            Clear Filters
          </Button>
        </div>
      </Form>
    );
  }
}

/**
 * Filter item
 */
export class FilterItem extends Component<FilterItemProps> {
  static defaultProps = {
    loading: false,
    disabled: false,
    value: undefined,
    defaultValue: undefined,
    size: "large",
    options: {
      input: {
        allowClear: false,
      },
      select: {
        allowClear: false,
        showSearch: false,
        optionFilterProp: "children",
      
      },
    },
    onChange: () => {},
  };

  render() {
    return <>
      <Form.Item label={this.props.label} style={{ marginBottom: 0 }}>
        {this.renderInput()}
      </Form.Item>
    </>
  }

  renderInput() {
    const {
      loading,
      disabled,
      value,
      defaultValue,
      name,
      type,
      placeholder,
      size,
      options,
      onChange,

    } = this.props;

    if (type === Types.SELECT) {
      const data = (this.props.data as Array<SelectData>) || [];
      const { select } = options;

      const parseValue = (val: any) => {
        if (!val) return undefined;

        if (typeof val === "object") {
          return JSON.stringify(val);
        }

        return val.toString();
      };

      return (
        <Select
          style={{ width: "100%" }}
          size={size}
          loading={loading}
          disabled={disabled}
          allowClear={select?.allowClear || false}
          showSearch={select?.showSearch || false}
          optionFilterProp={select?.optionFilterProp || "children"}
          placeholder={placeholder || "Select an option"}
          value={value || parseValue(defaultValue)}
          onChange={(value: any) => onChange({ fieldName: name, value })}
          onSearch={select?.onSearch}
          onDropdownVisibleChange={select?.onDropdownVisibleChange}
          
        >
          {data.map((option, index) => {
            return (
              <Select.Option
                key={`select-${name}-${index}`}
                value={parseValue(option.value) || ""}
              >
                {option.text}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    if (type === Types.INPUT) {
      const { input } = options;
      return (
        <Input
          style={{ width: "100%" }}
          size={size}
          allowClear={input?.allowClear || false}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={(ev) =>
            onChange({ fieldName: name, value: ev.currentTarget.value })
          }
        />
      );
    }
  }
}
